import { ComboboxOptions } from '@headlessui/react';
import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import DropdownOption from '../DropdownOption/DropdownOption';

const ComboboxOptionsWrapper = ({
  children,
  additionalDropdownClasses,
  testId,
  ...props
}) => {
  return (
    <ComboboxOptions
      className={twMerge(
        'absolute top-full mt-2 max-h-40 w-full rounded-md overflow-auto overflow-overlay',
        'scrollbar-sm bg-white dark:bg-gray-900 dark:border dark:border-gray-800 text-base shadow-md',
        'focus:outline-none z-20 transition ease-in duration-100 data-[closed]:opacity-0 ',
        'py-px', // when virtual scrolling is set, without set padding/height the options are not visible
        additionalDropdownClasses,
      )}
      as="ul"
      modal={false}
      {...getTestProps(testId, 'options')}
      {...props}
    >
      {children}
    </ComboboxOptions>
  );
};

const DropdownOptions = ({
  handleAddOnEmpty,
  groupedOptions,
  renderWithoutOptions,
  isVirtualScrolling,
  additionalDropdownClasses,
  additionalOptionsClasses,
  testId,
  ...props // headless ui passed props to combobox options
}) => {
  if (isVirtualScrolling) {
    return (
      <ComboboxOptionsWrapper
        additionalDropdownClasses={additionalDropdownClasses}
        testId={testId}
        {...props}
      >
        {({ option }) =>
          renderWithoutOptions ? (
            renderWithoutOptions
          ) : (
            <DropdownOption
              option={option}
              isVirtualScrolling={isVirtualScrolling}
              additionalOptionsClasses={additionalOptionsClasses}
              testId={testId}
            />
          )
        }
      </ComboboxOptionsWrapper>
    );
  }

  return (
    <ComboboxOptionsWrapper
      additionalDropdownClasses={additionalDropdownClasses}
      testId={testId}
      {...props}
    >
      {renderWithoutOptions
        ? renderWithoutOptions
        : Object.keys(groupedOptions).map((groupName) => (
            <Fragment key={groupName}>
              {groupName && (
                <li
                  className={twMerge(
                    'italic font-bold py-2 pl-4 pr-9 dark:text-white',
                  )}
                  key={groupName}
                  {...getTestProps(testId, `${groupName}-group`)}
                >
                  {groupName}
                </li>
              )}
              <>
                {handleAddOnEmpty}
                {groupedOptions[groupName].map((option) => (
                  <DropdownOption
                    key={option.value}
                    option={option}
                    additionalOptionsClasses={additionalOptionsClasses}
                    testId={testId}
                  />
                ))}
              </>
            </Fragment>
          ))}
    </ComboboxOptionsWrapper>
  );
};

export default DropdownOptions;
